import { render, staticRenderFns } from "./Teeth.vue?vue&type=template&id=4e0fbbcd&scoped=true&"
import script from "./Teeth.vue?vue&type=script&lang=js&"
export * from "./Teeth.vue?vue&type=script&lang=js&"
import style0 from "./Teeth.vue?vue&type=style&index=0&id=4e0fbbcd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0fbbcd",
  null
  
)

export default component.exports